import coreapi from 'coreapi'
import { combineReducers } from 'redux'
import { coreapiReducerGenerator } from './coreApiGenericReducer'
import { getSchema } from './schema'
import { action, get } from 'redux-coreapi'
import { checkNeedToRelogin } from './authorization'
// import Cookies from 'js-cookie'

// DJANGO CSRF
/** @namespace Cookies.get **/
// export const csrfToken = Cookies.get('csrftoken')

// export const schemaClient = new coreapi.Client({
//   headers: {
//     'Accept': 'application/coreapi+json',
//     'X-CSRFToken': csrfToken,
//   }
// })

export const schemaUrl = '/rest/schema'

export default combineReducers({
  // user: coreapiReducerGenerator('user', 'rest'),
  // group: coreapiReducerGenerator('group', 'rest'),
  article: coreapiReducerGenerator('article', 'rest'),
  comments: coreapiReducerGenerator('comments', 'rest'),
  treeEvent: coreapiReducerGenerator('treeEvent', 'rest'),
  treePotential: coreapiReducerGenerator('treePotential', 'rest'),
  treeStory: coreapiReducerGenerator('treeStory', 'rest'),
  treePerson: coreapiReducerGenerator('treePerson', 'rest'),
})

export function schemaClientGet () {
  return function (dispatch, getState) {
    let state = getState()
    let client
    if (state.authorization.access) {
      client = new coreapi.Client({
        headers: {
          'Accept': 'application/coreapi+json',
          'Authorization': 'Bearer ' + state.authorization.access
        }
      })
    } else {
      client = new coreapi.Client({
        headers: {
          'Accept': 'application/coreapi+json',
        }
      })
    }

    return dispatch(get(client, schemaUrl))
  }
}

export function clientAction (keys, params) {
  return function (dispatch, getState) {
    let state = getState()

    return checkNeedToRelogin(dispatch)(state.authorization).then(() => {
      // JWT causes your rest functions to be under rest in the schema
      keys.unshift('rest')
      let client = new coreapi.Client({
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + state.authorization.access
        }
      })
      return dispatch(action(client, getSchema(getState()), keys, params))
    })
  }
}
